export default "__VITE_ASSET__D5wg8Hp8__"